<template>
    <v-form ref="frmBpeHeader" lazy-validation class="pl-5 pr-5">
        <v-row>
            <v-col cols="3" md="2">
                <v-select
                    v-model="headerData.jobType"
                    :items=jobTypeList
                    item-text="text"
                    item-value="value"
                    label="ประเภทงาน"
                    placeholder=" "
                    outlined
                    :disabled="!canEdit"
                    :rules="[rules.required]"
                >
                </v-select>
            </v-col>
            <v-col v-if="headerData.jobType == 1">
                <v-autocomplete
                    v-model="selectedInsurance"
                    :items="insuranceList"
                    item-text="insName"
                    item-value="insCode"
                    label="บริษัทประกัน"
                    placeholder=" "
                    return-object
                    outlined
                    :disabled="!canEdit"
                >
                </v-autocomplete>
            </v-col>
            <v-col v-if="headerData.jobType == 1" cols="2" md="3">
                <v-radio-group row v-model="headerData.insType" :disabled="!canEdit">
                    
                    <v-radio label="ซ่อมอู่" value="2">
                    </v-radio>
                    <v-radio  label="ซ่อมห้าง" value="1">
                    </v-radio>
                </v-radio-group>
            </v-col>
            <v-col cols="1" >
                <v-text-field  
                    disabled flat   
                    label="ส่วนลดค่าแรง" suffix="%" placeholder=" " :value="headerData.laborDiscount">
                </v-text-field>
            </v-col>
            <v-col cols="1" >
                <v-text-field  
                    disabled flat   
                    label="ส่วนลดค่าอะไหล่" suffix="%" placeholder=" " :value="headerData.partDiscount">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row v-if="headerData.jobType == 1">
            <v-col>
                <v-text-field :disabled="!canEdit" maxlength="50" v-model="headerData.policyNo" label="หมายเลขกรรมธรรม์"  placeholder=" " outlined></v-text-field>
            </v-col>
            <v-col>
                <v-text-field :disabled="!canEdit" maxlength="50" v-model="headerData.acidentNo" label="เลขที่อุบัติเหตุ/รับแจ้ง"  placeholder=" " outlined></v-text-field>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>

import rules from '@/assets/js/rules.js'
import {listDropdownInsurance} from '@/api/common/dropdown-api.js'
export default {
    name: 'Bpeheader',
    props: {
        branchCode: {
            type: String
        },
        canEdit : {
            default: false,
            type: Boolean
        }
    },
    watch: {
        selectedInsurance: {
            handler(data){
                if (data == undefined || data.insCode == undefined) return;
                this.headerData.insCode = data.insCode;
                this.headerData.insName = data.insName;
                if(this.headerData.insType != undefined) {
                    if (data.laborDiscount != undefined) {
                        this.headerData.laborDiscount = data.laborDiscount;
                    } else {
                        this.headerData.laborDiscount =  this.headerData.insType == 1 ? parseInt(data.mallLaborDiscount) : parseInt(data.garageLaborDiscount);
                    }
                    
                    if (data.partDiscount != undefined) {
                        this.headerData.partDiscount = data.partDiscount;
                    } else {
                        this.headerData.partDiscount =  this.headerData.insType == 1 ? parseInt(data.mallPartDiscount) : parseInt(data.garagePartDiscount);
                    }
                    
                }
                this.$emit("setBpeHeader", this.headerData);
            },
            deep: true
        },
        "headerData.jobType": function(newVal) {
            if (newVal == '1') {
                this.insuranceList = [];
                this.selectedInsurance = Object.assign({}, this.defaultData);
                this.loadInsurance();
            } else {
                this.headerData.insCode = '';
                this.headerData.insType = '';
                this.headerData.laborDiscount = 0;
                this.headerData.partDiscount = 0;
            }
            this.$emit("setBpeHeader", this.headerData);
        },
        "headerData.insType": function(newVal) {
            if (!newVal || newVal == undefined) return;
            this.headerData.laborDiscount =  newVal == 1 ? this.selectedInsurance.mallLaborDiscount : this.selectedInsurance.garageLaborDiscount;
            this.headerData.partDiscount =  newVal == 1 ? this.selectedInsurance.mallPartDiscount : this.selectedInsurance.garagePartDiscount;
            this.$emit("setBpeHeader", this.headerData);
        }
        
    },
    data: () => ({
        jobTypeList: [
            {text: 'ประกัน', value: '1'},
            {text: 'เงินสด', value: '2'},
            {text: 'เครดิต', value: '3'},
            {text: 'งานภายใน', value: '4'}
        ],
        defaultJobTypeList: [
            {text: 'ประกัน', value: '1'},
            {text: 'เงินสด', value: '2'},
            {text: 'เครดิต', value: '3'},
            {text: 'งานภายใน', value: '4'}
        ],
        headerData: {
            jobType: '1',
            insCode: '',
            insName: '',
            insType: "1",
            policyNo: '',
            acidentNo: '',
            discount: 0
        },
        defaultData: {
            jobType: '1',
            insCode: '',
            insName: '',
            insType: "1",
            policyNo: '',
            acidentNo: '',
            mallLaborDiscount: 0,
            garageLaborDiscount: 0
        },
        rules: rules,
        selectedInsurance: {},
        insuranceList: []
    }),
    methods: {
        loadInsurance(callback) {
            this.jobTypeList = Object.assign([], this.defaultJobTypeList);
            listDropdownInsurance(this.branchCode, "1").then(rs => {
                this.insuranceList = rs;
                if (this.insuranceList != 'undefined' && this.insuranceList.length > 0) {
                    this.selectedInsurance = this.insuranceList[0];
                    this.headerData.jobType = '1';
                    this.headerData.insType = '1';
                } else {
                    this.headerData.jobType = '2';
                    this.jobTypeList = this.jobTypeList.slice(1);
                }
                if (callback) {
                    callback();
                }
            });
        },
        validate() {
            return this.$refs.frmBpeHeader.validate();
        },
        clearData() {
            //this.headerData = Object.assign({}, this.defaultData);
            //this.selectedInsurance.insCode = "";
        }, 
        setHeader(header) {
            this.selectedInsurance = {};
            let _this = this;
            
            if (header == undefined) {
                this.loadInsurance(function() {
                    _this.headerData.insType = '1';
                });
                return;
            }
            if (header != undefined && header.jobType != 1) {
                this.headerData = Object.assign({}, header);
                
            } else {
                if (this.insuranceList == undefined || this.insuranceList.length <= 0) {
                    this.loadInsurance(function() {
                        _this.setSelectedInsurance(header);
                    });
                } else {
                    this.setSelectedInsurance(header);
                }
            }
            
           
        },
        setSelectedInsurance(header) {
             if (header == undefined) {
                this.selectedInsurance = Object.assign({}, this.insuranceList[0]);
            } else {
               // this.selectedInsurance = Object.assign({}, header);
                this.headerData = Object.assign({}, header);
                this.selectedInsurance = this.insuranceList.filter(o => o.insCode == header.insCode)[0];
            }
        }
    },
    mounted() {
       // this.selectedInsurance = Object.assign({}, this.defaultData);
       /*
        this.$nextTick(() => {
            this.loadInsurance();
        });
        */
    }
}
</script>